import React from 'react';

import { useNavigate } from 'react-router-dom';
import { generateColumns, LimitsTable } from './LimitsTable';
import { adminApi } from '../../api';

function AdminLimitOverrides({ t, user, env }) {
  const navigate = useNavigate();
  const columns = generateColumns(t, env, true);
  const pageTitle = t('admin.limits.titleOverridePlural');

  return (
    <LimitsTable
      t={t}
      user={user}
      makeNew={() => navigate('/admin/limit_override/new')}
      generateRowUrl={(row) => `/admin/limit_override/${row.original.uuid}/detail`}
      pageTitle={pageTitle}
      columns={columns}
      fetchData={adminApi.fetchLimitOverrides}
      isLimitOverride
    />
  );
}

export default AdminLimitOverrides;
